import React from 'react';
import TemplateRoot from 'components/Layout/SiteOneTemplate';
import './404.scss';

const NotFoundPage = () => {
  const redirectUrl = window.profile.clientName
    ? `http://${window.location.host}`
    : `http://${window.location.host.split('.')[1]}`;

  return (
    <TemplateRoot>
      <div id='notfound'>
        <div className='notfound'>
          <div className='notfound-404'>
            <h1>404</h1>
          </div>
          <h2>Oops! Nothing was found</h2>
          <p>
            The page you are looking for might have been removed had its name
            changed or is temporarily unavailable.
            <a href={redirectUrl}> Return to homepage</a>
          </p>
        </div>
      </div>
    </TemplateRoot>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/errorPage/404.js